// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"cars-carousel-section_innerWrapper__emv7t"};